export default {
    type: 'text',
    config: {
        minWidth: {
            desktop: 200,
            mobile: 120
        },
        align: 'left'
    },
    default: {
        label: 'Game'
    },
    unique: [],
    sort: 'name',
    lang: {
        name: 'Game Name',
        views: ['list','sheet'],
        category: 'Game',
        description: 'Name of the game.'
    }
}